// removed by extract-text-webpack-plugin
module.exports = {"rupee-sign":"_1kxM","has-val":"_2K3F","pos-r":"_24XP","radio":"_XcID","wraper-type":"_2jru","select-head":"_CLun","radio-inp":"_2T0I","amt-section":"_23Ww"};


//////////////////
// WEBPACK FOOTER
// ./form/components/inputs/partial-amount/style.css
// module id = FHM5
// module chunks = 4